import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { PagingModule } from '../../components/common/search/paging.module';
import { RouterModule } from '@angular/router';
import { TooltipModule } from 'ngx-tooltip';
import { AuthModule } from '../../auth/auth.module';
import { CardPaymentModule } from '../../components/common/card.payment/card.payment.module';
import { BlockUIModule } from 'ng-block-ui';
import {TeamMemberSearchComponent} from './search.component';
import {AddTeamMemberComponent} from './add.team.member.component';

@NgModule({
    declarations: [TeamMemberSearchComponent, AddTeamMemberComponent],
    imports: [BrowserModule, FormsModule, PagingModule, RouterModule, TooltipModule, AuthModule, CardPaymentModule, BlockUIModule],
    exports: [TeamMemberSearchComponent]
})

export class TenderTeamMemberModule { }


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/tender.team.members/tender.team.member.module.ts